import signedFetch from '../apiCalls/util/signedFetch';

export default (classId, body) => signedFetch('selfEnrol', `${__API_BASE__}/class/${classId}/selfEnrol`, 'POST', body);
